// extracted by mini-css-extract-plugin
module.exports = {"bounce":"Check_bounce__cHE1f"};